export enum CyberAttackManagementTypeEnum {
    Manual = "Manual",
    BlockIp = "BlockIp",
    HoneyPot = "HoneyPot"
}